import React, { Fragment } from 'react';
import Input from '../../../layout/input/Input';
import InputTextArea from '../../../layout/input/InputTextArea';
import Panel from '../../../layout/panel/Panel';

class SocialMedia extends React.Component {
    constructor(props) {
        super(props);
    }

    printMsgTexto(titulo){
        if (titulo == 'Whatsapp'){
            titulo = `Informe o seu número do `;
        } else {
            titulo = `Informe o seu @ na Rede Social `;
        }
        return titulo;
    }

    printMsgLink(titulo){
        if (titulo == 'Whatsapp'){
            titulo = `Insira o link(API) do seu `;
        } else {
            titulo = `Insira o link do seu perfil na Rede Social `;
        }
        return titulo;
    }


    onChange(e, i) {        
        let lista = this.props.social;
        let opcao = lista[i];

        opcao[e.target.name] = e.target.value

        lista.splice(i, 1, opcao);
            
        this.props.onChangeForPropsSocial(lista);        
    }  

    render(){
        return(
            <section id="socialMedia">
                {this.props.social.map((item, i) => (
                    <Panel
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        title={item.titulo}
                        key={i}
                    >
                        <Input
                            md={12} 
                            xs={12} 
                            sm={12} 
                            lg={12}
                            id="texto"
                            nome="texto"
                            tooltip={this.printMsgTexto(item.titulo) + item.titulo}                     
                            value={item.texto}                                            
                            onChange={(e) => this.onChange(e, i)}
                        >
                            Texto:
                        </Input>
                        <Input
                            md={12} 
                            xs={12} 
                            sm={12} 
                            lg={12}
                            id="link"
                            nome="link"
                            tooltip={this.printMsgLink(item.titulo) + item.titulo}                                               
                            value={item.link}                                            
                            onChange={(e) => this.onChange(e, i)}
                        >
                            Link:
                        </Input>
                    </Panel>
                ))}  
                </section>
        )
    }

}

export default SocialMedia;